/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectFinancialSummaryCommand } from '../../models/delete-project-financial-summary-command';
import { DeleteProjectFinancialSummaryCommandResult } from '../../models/delete-project-financial-summary-command-result';

export interface ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Params {
      body?: DeleteProjectFinancialSummaryCommand
}

export function apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectFinancialSummaryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectFinancialSummaryCommandResult>;
    })
  );
}

apiProjectFinancialSummariesDeleteProjectFinancialSummaryDelete$Plain.PATH = '/api/ProjectFinancialSummaries/DeleteProjectFinancialSummary';
